var render = function render(){var _vm=this,_c=_vm._self._c;return _c('organization-and-user')
}
var staticRenderFns = []

export { render, staticRenderFns }